import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'

export const PayConditionService = {
  getAll: () => {
    return new Promise((resolve, reject) => {
      request(config.payConditions, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
}
